var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resultsComponent,_vm._b({ref:"results",tag:"component",attrs:{"items":_vm.results}},'component',_vm.resultsComponentProps,false))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2281f91e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/assets/js/theme-components/grid/DataGrid.vue
// module id = GeGk
// module chunks = 0